import { useIntl } from '~/techstyle-shared/react-intl';

import { isBuilderPreview } from './isBuilderPreview';

export const useBuilderContent = (content) => {
  const { locale } = useIntl();
  const queryLocale =
    locale === 'en-US' && isBuilderPreview() ? 'Default' : locale;

  return {
    content,
    locale: queryLocale,
  };
};
